import { CircularProgress, Container, Stack, Typography } from '@mui/material';
import { useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";

import userStore from '../../stores/User';

const LogoutAutoPage = () => {

  const history = useHistory();
  const user = userStore();

  useEffect(() => {
    user.clearAll();
    history.push({
      pathname: "/login", 
      state: { from: '/' }
    })
  });

  return (
    <>
      <Container
          sx={{ 
            height: '100vh',
            padding: '0px'
          }}
        >
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          sx={{ 
            height: '100vh',
            padding: '0px'
          }}
        >
          <CircularProgress />
          <Typography variant="h4">Session Expired</Typography>
        </Stack>
      </Container>
    </>
  );
}

export default LogoutAutoPage;